import styled from 'styled-components';
import { TabPanel } from 'react-tabs';
import { margin } from 'styled-system';
import { MarginProps } from '../../../theme/styledProps';

export const StepPanel = styled(TabPanel)<MarginProps>(margin);
